import { createSelector } from 'reselect';

import { EngineAvailabilityStore, namespace } from './store';

export const selectStore = (state: {
  [namespace]: EngineAvailabilityStore;
}): EngineAvailabilityStore => state[namespace];

export const selectAvailableEngineIds = createSelector(
  selectStore,
  (s) => s?.availableIds ?? null
);

/**
 * Whether an engine id can be run here.
 *
 * Returns TRUE while the answer is unknown. That is the whole optimistic
 * contract from `store.ts` in one place: a null answer means the check has not
 * finished, failed, or never ran, and none of those are evidence that the
 * engine is missing. The narrowing only ever takes effect once we have a real
 * answer, so a broken check degrades to today's behaviour rather than to an
 * empty dropdown.
 */
export const selectIsEngineAvailable = createSelector(
  selectAvailableEngineIds,
  (availableIds) => (engineId: string | undefined) =>
    !engineId || !availableIds || availableIds.includes(engineId)
);
